export default __webpack_public_path__ + "static/media/uttarakhand_logo.fa2a65d6.jpg";